module.exports = __webpack_public_path__ + "img/047.291fb07e.png";